
import { Component, ModelSync, Prop, Vue, Watch } from 'vue-property-decorator'
import CancelButton from '../buttons/CancelButton.vue'
import DangerButton from '../buttons/DangerButton.vue'
import { DeviceAccessUser } from '@/api/dtos/DeviceAccessUser.schema'
import { DeviceAccessTableRow } from '@/api/dtos/DeviceAccessTableRow.schema'
import { getDeviceAccessUsers, addDeviceAccessUser, removeDeviceAccessUser } from '@/api/stations'
import AddButton from '@/components/buttons/AddButton.vue'

@Component({
  components: {
    AddButton,
    DangerButton,
    CancelButton
  }
})
export default class AddPersonDialog extends Vue {
  readonly headers: {
    text: string;
    value: string;
    align?: 'start' | 'center' | 'end';
  }[] = [
    { text: 'Email', value: 'deviceEmail' },
    { text: 'Bereits registriert?', value: 'userFound' },
    { text: 'Aktion', value: 'actions' }
  ];

  @ModelSync('value', 'input')
  show!: boolean;

  @Prop()
  station!: string;

  @Prop()
  device!: number;

  emailToAdd = '';

  currentlyAddingUser = false;

  isDataValid = false;

  items: DeviceAccessTableRow[] = [];

  mounted (): void {
    this.getData()
  }

  async getData (): Promise<void> {
    try {
      const items = await getDeviceAccessUsers(this.station, this.device)

      this.items = items.map((i) => {
        return {
          id: i.id,
          deviceEmail: i.deviceEmail,
          userFound: i.userId == null ? 'Nein' : 'Ja'
        }
      })
    } catch (e) {
      console.error(e)
    }
  }

  async addAccess (): Promise<void> {
    try {
      this.currentlyAddingUser = true
      await addDeviceAccessUser(this.station, this.device, this.emailToAdd)
      await this.getData()
    } catch (e) {
      console.error(e)
    }
    this.currentlyAddingUser = false
    this.emailToAdd = ''
  }

  async removeAccess (item: DeviceAccessUser): Promise<void> {
    try {
      await removeDeviceAccessUser(this.station, this.device, item.id)
      await this.getData()
    } catch (e) {
      console.error(e)
    }
  }

  @Watch('device')
  deviceChanged (): void {
    this.items = []
    this.getData()
  }

  @Watch('station')
  stationChanged (): void {
    this.items = []
    this.getData()
  }
}
